import { 
    query_AValues_byAzienda, 
    query_BValues_byAzienda, 
    query_CValues_byAzienda, 
    query_PPE_byAzienda, 
    query_Prest_RischioInerente_ByAzienda, 
    query_RischioEffettivo_byAzienda, 
    query_RischioSpecifico_byAzienda, 
    query_RischioSpecificoCliente_byAzienda, 
    query_valutazioni_byAzienda, 
    query_ZonaGeografica_byAzienda, 
    query_zonaGeograficaPrestazione_ByAzienda,
    query_RischioSpecPrestazione_ByAzienda
} from "../query/autovalStatsQueries";
import sharedDatasInstance from "../sharedDatas";
import {useQuery} from "@1f/react-sdk";

export const StatsApi = () => {
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const query_PPE_byAziendaId = useQuery(
        query_PPE_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_EfAdeguataLivello_byAziendaId = useQuery(
        query_RischioSpecificoCliente_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_ZonaGeografica_byAziendaId = useQuery(
        query_ZonaGeografica_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_Valutazioni_byAziendaId = useQuery(
        query_valutazioni_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_Livelli_byAziendaId = useQuery(
        query_AValues_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_LivelliB_ByAziendaId = useQuery(
        query_BValues_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_LivelliC_ByAziendaId = useQuery(
        query_CValues_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )    
    const query_zonaGeograficaPrestazioniByAziendaId = useQuery(
        query_zonaGeograficaPrestazione_ByAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_RischioInerentePrestazioniByAziendaId = useQuery(
        query_Prest_RischioInerente_ByAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_RischioSpecificoPrestazioniByAziendaId = useQuery(
        query_RischioSpecifico_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const query_RischioSpecifico_byAziendaId = useQuery(
        query_RischioSpecPrestazione_ByAzienda,
        {},
        {lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const query_RischioEffettivoPrestazioniByAziendaId = useQuery(
        query_RischioEffettivo_byAzienda,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )

    const GetPPEByAzienda = async () => {
        try {
            let ppeResponse = await query_PPE_byAziendaId.fetch({
                aziendaId: aziendaId
            });        
            if(ppeResponse && ppeResponse.data && ppeResponse.data.data && ppeResponse.data.data.fascicolo) {
                let allAnag = ppeResponse.data.data.fascicolo.flatMap(f => f.anagrafica_fascicolos).filter(af=> af.TipoAnagId !== 1 && af.TipoAnagId !== 2)
                .map(af => af.anagrafica)                    
                let allAnagLength = allAnag.length;

                if(allAnagLength.length === 0){
                    return null
                }

                let pepCount = allAnag.filter(a => a.IsPep).length;
                let notPepMoreThanYearCount = allAnag.filter(a => a.IsNotPepMoreThanYear).length;
                return {
                    nonCostitiusce: { percent: Math.round(((allAnagLength-(pepCount+notPepMoreThanYearCount))/allAnagLength)*100), count: allAnagLength-(pepCount+notPepMoreThanYearCount), total: allAnagLength },
                    nonRiveste: { percent: Math.round((notPepMoreThanYearCount / allAnagLength) * 100), count: notPepMoreThanYearCount, total: allAnagLength },
                    costituisce: { percent: Math.round((pepCount / allAnagLength) * 100), count: pepCount, total: allAnagLength }
                }           
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i dati PPE: " + error.message);
        }
    }
    const GetEfAdeguataLivelloByAzienda = async () => {
        try {
            let efAdeguataResponse = await query_EfAdeguataLivello_byAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(efAdeguataResponse && efAdeguataResponse.data && efAdeguataResponse.data.data && efAdeguataResponse.data.data.rischio) {
                let allRischi = GetLastRischi(efAdeguataResponse.data.data.rischio)
                let allRischiCount = allRischi.length;

                if(allRischiCount === 0){
                    return null
                }                               

                let nonSignificativoCount = allRischi.filter(r => r.SpASubTotale/4 >= 1 && r.SpASubTotale/4 < 1.6).length;
                let pocoSignificativoCount = allRischi.filter(r => r.SpASubTotale/4 >= 1.6 && r.SpASubTotale/4 < 2.6).length;
                let abbastanzaSignificativoCount = allRischi.filter(r => r.SpASubTotale/4 >= 2.6 && r.SpASubTotale/4 < 3.6).length;
                let moltoSignificativoCount = allRischi.filter(r => r.SpASubTotale/4 >= 3.6).length;
                
                return {
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allRischiCount) * 100), count: nonSignificativoCount, total: allRischiCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allRischiCount) * 100), count: pocoSignificativoCount, total: allRischiCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allRischiCount) * 100), count: abbastanzaSignificativoCount, total: allRischiCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allRischiCount) * 100), count: moltoSignificativoCount, total: allRischiCount }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i dati EfAdeguataLivello: " + error.message);
        }
    }
    const GetZonaGeograficaByAzienda = async () => {
        try {
            let zoneResponse = await query_ZonaGeografica_byAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(zoneResponse && zoneResponse.data && zoneResponse.data.data && zoneResponse.data.data.fascicolo) {
                let allAnagraficheOfFascicoli = zoneResponse.data.data.fascicolo.flatMap(fascicolo =>
                    fascicolo.anagrafica_fascicolos.map(item => item.anagrafica)
                );

                let allAnagraficheCount = allAnagraficheOfFascicoli.length;
                if(allAnagraficheCount === 0){
                    return null
                }
                let nonZonaCount = allAnagraficheOfFascicoli.filter(a => a.base_provincium === null).length;
                let nonSignificativoCount = allAnagraficheOfFascicoli.filter(a => a.base_provincium?.Rischio === 1).length;
                let pocoSignificativoCount = allAnagraficheOfFascicoli.filter(a => a.base_provincium?.Rischio === 2).length;
                let abbastanzaSignificativoCount = allAnagraficheOfFascicoli.filter(a => a.base_provincium?.Rischio === 3).length;
                let moltoSignificativoCount = allAnagraficheOfFascicoli.filter(a => a.base_provincium?.Rischio === 4).length;
                return {
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allAnagraficheCount) * 100), count: nonSignificativoCount, total: allAnagraficheCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allAnagraficheCount) * 100), count: pocoSignificativoCount, total: allAnagraficheCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allAnagraficheCount) * 100), count: abbastanzaSignificativoCount, total: allAnagraficheCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allAnagraficheCount) * 100), count: moltoSignificativoCount, total: allAnagraficheCount },
                    senzaZona: { percent: Math.round((nonZonaCount / allAnagraficheCount) * 100), count: nonZonaCount, total: allAnagraficheCount }
                }
            }   
        } catch (error) {
            throw new Error("Impossibile recuperare i dati Zona Geografica: " + error.message);
        }
    }
    const GetValutazioniByAzienda = async () => {
        try {
            let valutazioniResponse = await query_Valutazioni_byAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(valutazioniResponse && valutazioniResponse.data && valutazioniResponse.data.data && valutazioniResponse.data.data.fascicolo) {
                let allPrest = valutazioniResponse.data.data.fascicolo.flatMap(f => f.prestaziones)
                let allPrestCount = allPrest.length;
                if(allPrestCount === 0){
                    return null
                }
                let valutazioniCreateCount = allPrest.flatMap(p => p.rischios).filter(v => v.Date != null).length;
                return {
                    registrate: { percent: Math.round((valutazioniCreateCount / allPrestCount) * 100), count: valutazioniCreateCount, total: allPrestCount },
                    nonRegistrate: { percent: Math.round(((allPrestCount - valutazioniCreateCount) / allPrestCount) * 100), count: (allPrestCount - valutazioniCreateCount), total: allPrestCount }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i dati Valutazioni: " + error.message);
        }
    }
    const GetALivelliByAzienda = async () => {
        try {
            let livelliResponse = await query_Livelli_byAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(livelliResponse && livelliResponse.data && livelliResponse.data.data && livelliResponse.data.data.rischio) {
                let allRischi = GetLastRischi(livelliResponse.data.data.rischio)
                if(allRischi.length === 0){ 
                    return null
                }

                let a1Total = allRischi.filter(p => p.SpA1Livello != null).length;
                let spA1NonSignificativoCount = allRischi.filter(r => r.SpA1Livello === 1).length;
                let spA1PocoSignificativoCount = allRischi.filter(r => r.SpA1Livello === 2).length;
                let spA1AbbastanzaSignificativoCount = allRischi.filter(r => r.SpA1Livello === 3).length;
                let spA1MoltoSignificativoCount = allRischi.filter(r => r.SpA1Livello === 4).length;

                let a2Total = allRischi.filter(p => p.SpA2Livello != null).length;
                let spA2NonSignificativoCount = allRischi.filter(r => r.SpA2Livello === 1).length;
                let spA2PocoSignificativoCount = allRischi.filter(r => r.SpA2Livello === 2).length;
                let spA2AbbastanzaSignificativoCount = allRischi.filter(r => r.SpA2Livello === 3).length;
                let spA2MoltoSignificativoCount = allRischi.filter(r => r.SpA2Livello === 4).length;

                let a3Total = allRischi.filter(p => p.SpA3Livello != null).length;
                let spA3NonSignificativoCount = allRischi.filter(r => r.SpA3Livello === 1).length;
                let spA3PocoSignificativoCount = allRischi.filter(r => r.SpA3Livello === 2).length;
                let spA3AbbastanzaSignificativoCount = allRischi.filter(r => r.SpA3Livello === 3).length;
                let spA3MoltoSignificativoCount = allRischi.filter(r => r.SpA3Livello === 4).length;

                let a4Total = allRischi.filter(p => p.SpA4Livello != null).length;
                let spA4NonSignificativoCount = allRischi.filter(r => r.SpA4Livello === 1).length;
                let spA4PocoSignificativoCount = allRischi.filter(r => r.SpA4Livello === 2).length;
                let spA4AbbastanzaSignificativoCount = allRischi.filter(r => r.SpA4Livello === 3).length;
                let spA4MoltoSignificativoCount = allRischi.filter(r => r.SpA4Livello === 4).length;

                return {
                    naturaGiuridicaPunteggio: {
                        nonSignificativo: { percent: Math.round((spA1NonSignificativoCount / a1Total) * 100), count: spA1NonSignificativoCount, total: a1Total },
                        pocoSignificativo: { percent: Math.round((spA1PocoSignificativoCount / a1Total) * 100), count: spA1PocoSignificativoCount, total: a1Total },
                        abbastanzaSignificativo: { percent: Math.round((spA1AbbastanzaSignificativoCount / a1Total) * 100), count: spA1AbbastanzaSignificativoCount, total: a1Total },
                        moltoSignificativo: { percent: Math.round((spA1MoltoSignificativoCount / a1Total) * 100), count: spA1MoltoSignificativoCount, total: a1Total }
                    },
                    attivitaSvoltaPunteggio : {
                        nonSignificativo: { percent: Math.round((spA2NonSignificativoCount / a2Total) * 100), count: spA2NonSignificativoCount, total: a2Total },
                        pocoSignificativo: { percent: Math.round((spA2PocoSignificativoCount / a2Total) * 100), count: spA2PocoSignificativoCount, total: a2Total },
                        abbastanzaSignificativo: { percent: Math.round((spA2AbbastanzaSignificativoCount / a2Total) * 100), count: spA2AbbastanzaSignificativoCount, total: a2Total },
                        moltoSignificativo: { percent: Math.round((spA2MoltoSignificativoCount / a2Total) * 100), count: spA2MoltoSignificativoCount, total: a2Total }
                    },
                    comportamentoPunteggio : {
                        nonSignificativo: { percent: Math.round((spA3NonSignificativoCount / a3Total) * 100), count: spA3NonSignificativoCount, total: a3Total },
                        pocoSignificativo: { percent: Math.round((spA3PocoSignificativoCount / a3Total) * 100), count: spA3PocoSignificativoCount, total: a3Total },
                        abbastanzaSignificativo: { percent: Math.round((spA3AbbastanzaSignificativoCount / a3Total) * 100), count: spA3AbbastanzaSignificativoCount, total: a3Total },
                        moltoSignificativo: { percent: Math.round((spA3MoltoSignificativoCount / a3Total) * 100), count: spA3MoltoSignificativoCount, total: a3Total }
                    },
                    areaGeograficaPunteggio : {
                        nonSignificativo: { percent: Math.round((spA4NonSignificativoCount / a4Total) * 100), count: spA4NonSignificativoCount, total: a4Total },
                        pocoSignificativo: { percent: Math.round((spA4PocoSignificativoCount / a4Total) * 100), count: spA4PocoSignificativoCount, total: a4Total },
                        abbastanzaSignificativo: { percent: Math.round((spA4AbbastanzaSignificativoCount / a4Total) * 100), count: spA4AbbastanzaSignificativoCount, total: a4Total },
                        moltoSignificativo: { percent: Math.round((spA4MoltoSignificativoCount / a4Total) * 100), count: spA4MoltoSignificativoCount, total: a4Total }
                    }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i dati Livelli: " + error.message);
        }
    }   
    const GetBLivelliByAzienda = async () => {
        try {
            let livelliBResponse = await query_LivelliB_ByAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(livelliBResponse && livelliBResponse.data && livelliBResponse.data.data && livelliBResponse.data.data.rischio) {
                
                let allRischi =  GetLastRischi(livelliBResponse.data.data.rischio)                
                if(allRischi.length === 0){
                    return null
                } 
                
                let spB1NonSignificativoCount = allRischi.filter(r => r.SpB1Livello === 1).length;
                let spB1PocoSignificativoCount = allRischi.filter(r => r.SpB1Livello === 2).length;
                let spB1AbbastanzaSignificativoCount = allRischi.filter(r => r.SpB1Livello === 3).length;
                let spB1MoltoSignificativoCount = allRischi.filter(r => r.SpB1Livello === 4).length;

                let spB2NonSignificativoCount = allRischi.filter(r => r.SpB2Livello === 1).length;
                let spB2PocoSignificativoCount = allRischi.filter(r => r.SpB2Livello === 2).length;
                let spB2AbbastanzaSignificativoCount = allRischi.filter(r => r.SpB2Livello === 3).length;
                let spB2MoltoSignificativoCount = allRischi.filter(r => r.SpB2Livello === 4).length;

                let spB3NonSignificativoCount = allRischi.filter(r => r.SpB3Livello === 1).length;
                let spB3PocoSignificativoCount = allRischi.filter(r => r.SpB3Livello === 2).length;
                let spB3AbbastanzaSignificativoCount = allRischi.filter(r => r.SpB3Livello === 3).length;
                let spB3MoltoSignificativoCount = allRischi.filter(r => r.SpB3Livello === 4).length;

                let spB4NonSignificativoCount = allRischi.filter(r => r.SpB4Livello === 1).length;
                let spB4PocoSignificativoCount = allRischi.filter(r => r.SpB4Livello === 2).length;
                let spB4AbbastanzaSignificativoCount = allRischi.filter(r => r.SpB4Livello === 3).length;
                let spB4MoltoSignificativoCount = allRischi.filter(r => r.SpB4Livello === 4).length;

                let spB5NonSignificativoCount = allRischi.filter(r => r.SpB5Livello === 1).length;
                let spB5PocoSignificativoCount = allRischi.filter(r => r.SpB5Livello === 2).length;
                let spB5AbbastanzaSignificativoCount = allRischi.filter(r => r.SpB5Livello === 3).length;
                let spB5MoltoSignificativoCount = allRischi.filter(r => r.SpB5Livello === 4).length;

                let spB6NonSignificativoCount = allRischi.filter(r => r.SpB6Livello === 1).length;
                let spB6PocoSignificativoCount = allRischi.filter(r => r.SpB6Livello === 2).length;
                let spB6AbbastanzaSignificativoCount = allRischi.filter(r => r.SpB6Livello === 3).length;
                let spB6MoltoSignificativoCount = allRischi.filter(r => r.SpB6Livello === 4).length;

                return {
                    b1Punteggio: {
                        nonSignificativo: { percent: Math.round((spB1NonSignificativoCount / allRischi.length) * 100), count: spB1NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spB1PocoSignificativoCount / allRischi.length) * 100), count: spB1PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spB1AbbastanzaSignificativoCount / allRischi.length) * 100), count: spB1AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spB1MoltoSignificativoCount / allRischi.length) * 100), count: spB1MoltoSignificativoCount, total: allRischi.length }
                    },
                    b2Punteggio : {
                        nonSignificativo: { percent: Math.round((spB2NonSignificativoCount / allRischi.length) * 100), count: spB2NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spB2PocoSignificativoCount / allRischi.length) * 100), count: spB2PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spB2AbbastanzaSignificativoCount / allRischi.length) * 100), count: spB2AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spB2MoltoSignificativoCount / allRischi.length) * 100), count: spB2MoltoSignificativoCount, total: allRischi.length }
                    },
                    b3Punteggio : {
                        nonSignificativo: { percent: Math.round((spB3NonSignificativoCount / allRischi.length) * 100), count: spB3NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spB3PocoSignificativoCount / allRischi.length) * 100), count: spB3PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spB3AbbastanzaSignificativoCount / allRischi.length) * 100), count: spB3AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spB3MoltoSignificativoCount / allRischi.length) * 100), count: spB3MoltoSignificativoCount, total: allRischi.length }                        
                    },
                    b4Punteggio : {
                        nonSignificativo: { percent: Math.round((spB4NonSignificativoCount / allRischi.length) * 100), count: spB4NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spB4PocoSignificativoCount / allRischi.length) * 100), count: spB4PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spB4AbbastanzaSignificativoCount / allRischi.length) * 100), count: spB4AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spB4MoltoSignificativoCount / allRischi.length) * 100), count: spB4MoltoSignificativoCount, total: allRischi.length }                        
                    },
                    b5Punteggio : {
                        nonSignificativo: { percent: Math.round((spB5NonSignificativoCount / allRischi.length) * 100), count: spB5NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spB5PocoSignificativoCount / allRischi.length) * 100), count: spB5PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spB5AbbastanzaSignificativoCount / allRischi.length) * 100), count: spB5AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spB5MoltoSignificativoCount / allRischi.length) * 100), count: spB5MoltoSignificativoCount, total: allRischi.length }                        
                    },
                    b6Punteggio : {
                        nonSignificativo: { percent: Math.round((spB6NonSignificativoCount / allRischi.length) * 100), count: spB6NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spB6PocoSignificativoCount / allRischi.length) * 100), count: spB6PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spB6AbbastanzaSignificativoCount / allRischi.length) * 100), count: spB6AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spB6MoltoSignificativoCount / allRischi.length) * 100), count: spB6MoltoSignificativoCount, total: allRischi.length }
                    }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i dati Livelli B: " + error.message);
        }
    }
    const GetCLivelliByAzienda = async () => {
        try {
            let livelliCResponse = await query_LivelliC_ByAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(livelliCResponse && livelliCResponse.data && livelliCResponse.data.data && livelliCResponse.data.data.fascicolo) {
                let allRischi = livelliCResponse.data.data.fascicolo.flatMap(f => f.prestaziones.flatMap(p => p.rischios))
                
                if(allRischi.length === 0){
                    return null
                } 
                
                let spC1NonSignificativoCount = allRischi.filter(r => r.SpC1_1_Livello === 1).length;
                let spC1PocoSignificativoCount = allRischi.filter(r => r.SpC1_1_Livello === 2).length;
                let spC1AbbastanzaSignificativoCount = allRischi.filter(r => r.SpC1_1_Livello === 3).length;
                let spC1MoltoSignificativoCount = allRischi.filter(r => r.SpC1_1_Livello === 4).length;

                let spC2NonSignificativoCount = allRischi.filter(r => r.SpC1_2_Livello === 1).length;
                let spC2PocoSignificativoCount = allRischi.filter(r => r.SpC1_2_Livello === 2).length;
                let spC2AbbastanzaSignificativoCount = allRischi.filter(r => r.SpC1_2_Livello === 3).length;
                let spC2MoltoSignificativoCount = allRischi.filter(r => r.SpC1_2_Livello === 4).length;

                let spC3NonSignificativoCount = allRischi.filter(r => r.SpC1_3_Livello === 1).length;
                let spC3PocoSignificativoCount = allRischi.filter(r => r.SpC1_3_Livello === 2).length;
                let spC3AbbastanzaSignificativoCount = allRischi.filter(r => r.SpC1_3_Livello === 3).length;
                let spC3MoltoSignificativoCount = allRischi.filter(r => r.SpC1_3_Livello === 4).length;

                return {
                    c1Punteggio: {
                        nonSignificativo: { percent: Math.round((spC1NonSignificativoCount / allRischi.length) * 100), count: spC1NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spC1PocoSignificativoCount / allRischi.length) * 100), count: spC1PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spC1AbbastanzaSignificativoCount / allRischi.length) * 100), count: spC1AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spC1MoltoSignificativoCount / allRischi.length) * 100), count: spC1MoltoSignificativoCount, total: allRischi.length }
                    },
                    c2Punteggio : {
                        nonSignificativo: { percent: Math.round((spC2NonSignificativoCount / allRischi.length) * 100), count: spC2NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spC2PocoSignificativoCount / allRischi.length) * 100), count: spC2PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spC2AbbastanzaSignificativoCount / allRischi.length) * 100), count: spC2AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spC2MoltoSignificativoCount / allRischi.length) * 100), count: spC2MoltoSignificativoCount, total: allRischi.length }
                    },
                    c3Punteggio : {
                        nonSignificativo: { percent: Math.round((spC3NonSignificativoCount / allRischi.length) * 100), count: spC3NonSignificativoCount, total: allRischi.length },
                        pocoSignificativo: { percent: Math.round((spC3PocoSignificativoCount / allRischi.length) * 100), count: spC3PocoSignificativoCount, total: allRischi.length },
                        abbastanzaSignificativo: { percent: Math.round((spC3AbbastanzaSignificativoCount / allRischi.length) * 100), count: spC3AbbastanzaSignificativoCount, total: allRischi.length },
                        moltoSignificativo: { percent: Math.round((spC3MoltoSignificativoCount / allRischi.length) * 100), count: spC3MoltoSignificativoCount, total: allRischi.length }
                    }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i dati Livelli: " + error.message);
        }
    }    
    const GetPrestazioniZonaGeografica = async () => {
        try {
            let prestazioniZonaGeoResponse = await query_zonaGeograficaPrestazioniByAziendaId.fetch({
                aziendaId: aziendaId
            })
            if(prestazioniZonaGeoResponse && prestazioniZonaGeoResponse.data && prestazioniZonaGeoResponse.data.data && prestazioniZonaGeoResponse.data.data.fascicolo){
                let allPrestazioni = prestazioniZonaGeoResponse.data.data.fascicolo.flatMap(fascicolo =>
                    fascicolo.prestaziones.map(item => item)
                );

                let allPrestazioniCount = allPrestazioni.length;
                if(allPrestazioniCount === 0){
                    return null
                }
                let nonZonaCount = allPrestazioni.filter(a => a.base_provincium === null).length;
                let nonSignificativoCount = allPrestazioni.filter(a => a.base_provincium?.Rischio === 1).length;
                let pocoSignificativoCount = allPrestazioni.filter(a => a.base_provincium?.Rischio === 2).length;
                let abbastanzaSignificativoCount = allPrestazioni.filter(a => a.base_provincium?.Rischio === 3).length;
                let moltoSignificativoCount = allPrestazioni.filter(a => a.base_provincium?.Rischio === 4).length;
                return {
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allPrestazioniCount) * 100), count: nonSignificativoCount, total: allPrestazioniCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allPrestazioniCount) * 100), count: pocoSignificativoCount, total: allPrestazioniCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allPrestazioniCount) * 100), count: abbastanzaSignificativoCount, total: allPrestazioniCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allPrestazioniCount) * 100), count: moltoSignificativoCount, total: allPrestazioniCount },
                    senzaZona: { percent: Math.round((nonZonaCount / allPrestazioniCount) * 100), count: nonZonaCount, total: allPrestazioniCount }
                }
            }
        }
        catch (error){
            throw new Error("Impossibile recuperare i dati delle prestazioni per zona geografica: " + error.message);
        }
    }
    const GetPrestazioniRischioInerente = async () => {
        try {
            let rischioInerenteResponse = await query_RischioInerentePrestazioniByAziendaId.fetch({
                aziendaId : aziendaId   
            })
            if(rischioInerenteResponse && rischioInerenteResponse.data && rischioInerenteResponse.data.data && rischioInerenteResponse.data.data.fascicolo) {
                let allPrestazioni = rischioInerenteResponse.data.data.fascicolo.flatMap(fascicolo =>
                    fascicolo.prestaziones.map(item => item)
                );

                let allPrestazioniCount = allPrestazioni.length;
                if(allPrestazioniCount === 0){
                    return null
                }

                let nonSignificativoCount = allPrestazioni.filter(a => a.base_tipo_prestazione?.Rischio === 1).length;
                let pocoSignificativoCount = allPrestazioni.filter(a => a.base_tipo_prestazione?.Rischio === 2).length;
                let abbastanzaSignificativoCount = allPrestazioni.filter(a => a.base_tipo_prestazione?.Rischio === 3).length;
                let moltoSignificativoCount = allPrestazioni.filter(a => a.base_tipo_prestazione?.Rischio === 4).length;
                return {
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allPrestazioniCount) * 100), count: nonSignificativoCount, total: allPrestazioniCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allPrestazioniCount) * 100), count: pocoSignificativoCount, total: allPrestazioniCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allPrestazioniCount) * 100), count: abbastanzaSignificativoCount, total: allPrestazioniCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allPrestazioniCount) * 100), count: moltoSignificativoCount, total: allPrestazioniCount },
                }
            }                            
        } catch (error) {
            throw  new Error("Impossibile recuperare i rischi inerenti alle prestazioni: " + error.message)
        }
    }
    const GetPrestazioniRischioComplessivo = async () =>{
        try {
            let prestSpecResponse = await query_RischioSpecificoPrestazioniByAziendaId.fetch({
                aziendaId:aziendaId
            })
            if(prestSpecResponse && prestSpecResponse.data && prestSpecResponse.data.data && prestSpecResponse.data.data.rischio){
                let allRischi = GetLastRischi(prestSpecResponse.data.data.rischio)
                let allRischiCount = allRischi.length
                if(allRischi.length === 0){
                    return null
                }

                let nonSignificativoCount = allRischi.filter(r => r.EfSpTotale >= 0 && r.EfSpTotale < 1.6).length;
                let pocoSignificativoCount = allRischi.filter(r => r.EfSpTotale >= 1.6 && r.EfSpTotale < 2.6).length;
                let abbastanzaSignificativoCount = allRischi.filter(r => r.EfSpTotale >= 2.6 && r.EfSpTotale < 3.6).length;
                let moltoSignificativoCount = allRischi.filter(r => r.EfSpTotale >= 3.6).length;

                return{
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allRischiCount) * 100), count: nonSignificativoCount, total: allRischiCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allRischiCount) * 100), count: pocoSignificativoCount, total: allRischiCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allRischiCount) * 100), count: abbastanzaSignificativoCount, total: allRischiCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allRischiCount) * 100), count: moltoSignificativoCount, total: allRischiCount }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i rischi specifici delle prestazioni: " + error.message)
        }
    }
    const GetPrestazioniRischioSpecifico = async () => {
        try {
            let prestSpecResponse = await query_RischioSpecifico_byAziendaId.fetch({
                aziendaId:aziendaId
            })
            if(prestSpecResponse && prestSpecResponse.data && prestSpecResponse.data.data && prestSpecResponse.data.data.rischio){
                let allRischi = GetLastRischi(prestSpecResponse.data.data.rischio);
                                
                let allRischiCount = allRischi.length;
                if(allRischiCount === 0){
                    return null
                }

                let nonSignificativoCount = allRischi.filter(r => r.SpBSubTotale/6 >= 0 && r.SpBSubTotale/6 < 1.6).length;
                let pocoSignificativoCount = allRischi.filter(r => r.SpBSubTotale/6 >= 1.6 && r.SpBSubTotale/6 < 2.6).length;
                let abbastanzaSignificativoCount = allRischi.filter(r => r.SpBSubTotale/6 >= 2.6 && r.SpBSubTotale/6 < 3.6).length;
                let moltoSignificativoCount = allRischi.filter(r => r.SpBSubTotale/6 >= 3.6).length;
                return {
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allRischiCount) * 100), count: nonSignificativoCount, total: allRischiCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allRischiCount) * 100), count: pocoSignificativoCount, total: allRischiCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allRischiCount) * 100), count: abbastanzaSignificativoCount, total: allRischiCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allRischiCount) * 100), count: moltoSignificativoCount, total: allRischiCount },
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i rischi specifici delle prestazioni: " + error.message)
        }
    }
    const GetPrestazioniRischioEffettivo = async () =>{
        try {
            let prestEffResponse = await query_RischioEffettivoPrestazioniByAziendaId.fetch({
                aziendaId:aziendaId
            })
            if(prestEffResponse && prestEffResponse.data && prestEffResponse.data.data && prestEffResponse.data.data.rischio){
                let allRischi = GetLastRischi(prestEffResponse.data.data.rischio)
                let allRischiCount = allRischi.length
                if(allRischi.length === 0){
                    return null
                }

                let nonSignificativoCount = allRischi.filter(r => r.EfTotale >= 1 && r.EfTotale < 1.6).length;
                let pocoSignificativoCount = allRischi.filter(r => r.EfTotale >= 1.6 && r.EfTotale < 2.6).length;
                let abbastanzaSignificativoCount = allRischi.filter(r => r.EfTotale >= 2.6 && r.EfTotale < 3.6).length;
                let moltoSignificativoCount = allRischi.filter(r => r.EfTotale >= 3.6).length;

                return{
                    nonSignificativo: { percent: Math.round((nonSignificativoCount / allRischiCount) * 100), count: nonSignificativoCount, total: allRischiCount },
                    pocoSignificativo: { percent: Math.round((pocoSignificativoCount / allRischiCount) * 100), count: pocoSignificativoCount, total: allRischiCount },
                    abbastanzaSignificativo: { percent: Math.round((abbastanzaSignificativoCount / allRischiCount) * 100), count: abbastanzaSignificativoCount, total: allRischiCount },
                    moltoSignificativo: { percent: Math.round((moltoSignificativoCount / allRischiCount) * 100), count: moltoSignificativoCount, total: allRischiCount }
                }
            }
        } catch (error) {
            throw new Error("Impossibile recuperare i rischi specifici delle prestazioni: " + error.message)
        }
    }
    const GetLastRischi = (allRischi) => {
        const mappa = new Map();
        for (const rischio of allRischi) {
            const chiave = `${rischio.PrestazioneId}_${rischio.ProvidedBy}`;

            if (!mappa.has(chiave)) {
            mappa.set(chiave, rischio);
            } else {
            const esistente = mappa.get(chiave);
            if (new Date(rischio.Date) > new Date(esistente.Date)) {
                mappa.set(chiave, rischio);
            }
            }
        }

        return Array.from(mappa.values());
    }
    
    return {
        GetPPEByAzienda,
        GetEfAdeguataLivelloByAzienda,
        GetZonaGeograficaByAzienda,
        GetValutazioniByAzienda,
        GetALivelliByAzienda,
        GetBLivelliByAzienda,
        GetCLivelliByAzienda,
        GetPrestazioniZonaGeografica,
        GetPrestazioniRischioInerente,
        GetPrestazioniRischioComplessivo,
        GetPrestazioniRischioSpecifico,
        GetPrestazioniRischioEffettivo
    }
}